import React, { useState, useEffect, Fragment } from "react";

import { useSelector, useDispatch } from "react-redux";

import Card from "../../component/card/Card";
import Starter from "../../component/Starter";
import TableHeader from "../../component/tableHeader/TableHeader";
import { helperFunction } from "../../constant/helper";
import useSortableData from "../../customHooks/sortingHooks";
import { userActions } from "../../redux/actions";
import AddDeviceModal from "./AddDeviceModal";
import DeviceList from "./DeviceList";
import { tableHeaderData } from "./deviceStaticData";
import TopInput from "./TopInput";

const initialState = {
  Filter: "",
  workerId: "",
  modelName: "",
  locationId: "",
  workerName: "",
  deviceName: "",
  workerNumber: "",
  selectedLocationId: ""
};

const AllDevices = () => {
  const loginType = localStorage.loginType;
  const dispatch = useDispatch();

  const [values, setValues] = useState(initialState);
  const [allDevices, setAllDevices] = useState([]);
  const [allLocations, setAllLocations] = useState([]);

  const { locations } = useSelector((state) => state.location);
  const { currentUser } = useSelector((state) => state.auth);

  const {
    devices,
    userError,
    userLoading,
    userResponse,
    addDeviceLoading
  } = useSelector((state) => state.user);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    if (devices !== null) {
      setAllDevices(devices);
    } else {
      setAllDevices([]);
    }
  }, [devices]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    if (userError) {
      helperFunction.toastHelper("error", userError);
    }
    if (userResponse) {
      helperFunction.toastHelper("success", userResponse);
    }
  }, [userError, userResponse]);

  const onGetAllDevices = (e) => {
    e.preventDefault();
    dispatch(userActions.setUserLoading(true));
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    dispatch(userActions.getDevices(values.locationId, loginType));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const deviceData = {
      workerId: values.workerId.toUpperCase(),
      modelName: values.modelName.toUpperCase(),
      workerName: values.workerName.toUpperCase(),
      deviceName: values.deviceName.toUpperCase(),
      locationId: values.selectedLocationId,
      createdBy: localStorage.getItem("id"),
      workerNumber: values.workerNumber.toUpperCase(),
      createdByIp: localStorage.getItem("publicIpAdd"),
      createdAtLocation: [
        localStorage.getItem("latitude"),
        localStorage.getItem("longitude")
      ]
    };
    dispatch(userActions.setAddDeviceLoading(true));
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());

    dispatch(userActions.addDevices(deviceData, loginType));
  };

  const onDeleteDevice = (deviceDetails) => {
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    const deleteData = {
      deviceId: deviceDetails._id
    };
    dispatch(userActions.deleteDevices(deleteData, loginType));
  };

  const { items, requestSort, sortConfig } = useSortableData(
    allDevices
  );

  return (
    <Starter
      topBarTitle="All Devices"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Admin Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Access</a>
          </li>
          <li className="breadcrumb-item active">All Devices</li>
        </Fragment>
      }
    >
      <Card>
        <TopInput
          values={values}
          loading={userLoading}
          currentUser={currentUser}
          onSubmit={onGetAllDevices}
          allLocations={allLocations}
          onChange={handleInputChange}
        />
        <AddDeviceModal
          values={values}
          onSubmit={onSubmit}
          currentUser={currentUser}
          allLocations={allLocations}
          onChange={handleInputChange}
          userLoading={addDeviceLoading}
        />
        <div className="table-responsive">
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th style={{ width: "20px" }}>#</th>
                <TableHeader
                  sortConfig={sortConfig}
                  requestSort={requestSort}
                  tableHeaderData={tableHeaderData}
                />
                <th>Created At</th>
                <th>Created By</th>
                <th>Ip Address</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <DeviceList
                deviceList={items}
                deviceLoading={userLoading}
                onDeleteDevice={onDeleteDevice}
              />
            </tbody>
          </table>
        </div>
      </Card>
    </Starter>
  );
};

export default AllDevices;
